import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ variant = 'default' }) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const languages = [
        { code: 'nl', flag: '🇳🇱', name: 'Nederlands' },
        { code: 'en', flag: '🇬🇧', name: 'English' },
        { code: 'pl', flag: '🇵🇱', name: 'Polski' },
        { code: 'hu', flag: '🇭🇺', name: 'Magyar' }
    ];

    const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('preferredLanguage', lng);
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // Dropdown variant for desktop navigation
    if (variant === 'dropdown') {
        return (
            <div className="language-switcher language-switcher-dropdown" ref={dropdownRef}>
                <button
                    className={`lang-dropdown-btn ${isOpen ? 'open' : ''}`}
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label="Select Language"
                    aria-expanded={isOpen}
                >
                    <span className="lang-flag">{currentLanguage.flag}</span>
                    <span className="lang-dropdown-arrow">▼</span>
                </button>

                {isOpen && (
                    <div className="lang-dropdown-menu">
                        {languages.map(lang => (
                            <button
                                key={lang.code}
                                onClick={() => changeLanguage(lang.code)}
                                className={`lang-dropdown-item ${i18n.language === lang.code ? 'active' : ''}`}
                                aria-label={`Switch to ${lang.name}`}
                            >
                                <span className="lang-flag">{lang.flag}</span>
                                <span className="lang-name">{lang.name}</span>
                                {i18n.language === lang.code && <span className="lang-check">✓</span>}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    // Default buttons variant (auth pages, mobile)
    return (
        <div className={`language-switcher language-switcher-${variant}`}>
            {languages.map(lang => (
                <button
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    className={`lang-btn ${i18n.language === lang.code ? 'active' : ''}`}
                    title={lang.name}
                    aria-label={`Switch to ${lang.name}`}
                >
                    <span className="lang-flag">{lang.flag}</span>
                    {variant === 'full' && <span className="lang-name">{lang.name}</span>}
                </button>
            ))}
        </div>
    );
};

export default LanguageSwitcher;

